// client/src/pages/LandingPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';

function LandingPage() {
  const { isSignedIn } = useAuth();
  
  // If user is signed in, redirect to dashboard
  if (isSignedIn) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return (
    <div className="landing-page">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white py-20 mt-0 w-screen right-[50%] relative left-[50%] right-[50%] mx-[-50vw]">
        <div className="container max-w-6xl mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-10 md:mb-0">
              <h1 className="text-4xl md:text-5xl mr-5 font-bold leading-tight mb-4">
              The Most Advanced QR Code Creator and Link Tracking Solution
              </h1>
              <p className="text-xl mb-8 mr-5">
            Create free stunning custom QR codes. All-in-one analytics with dynamic URLs you can update anytime. Get location data, device insights, and conversion metrics in one powerful platform.
              </p>
              <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <Link to="/QRcreator" className="flex justify-center bg-white text-blue-700 border-2 border-white hover:bg-blue-200 hover:text-blue-800 px-10 py-5 rounded-lg font-semibold transition text-center duration-200">
              Create Free QR Codes
                </Link>
                
                <Link to="/benefits" className="flex bg-transparent justify-center border-2 text-white border-white hover:bg-blue-600 hover:text-white px-10 py-5 rounded-lg font-semibold text-center transition duration-200">
                Why Choose BoxyQR
                </Link>
              </div>
              <div className="mt-5 font-medium text-xs text-white"></div>

            </div>
            <div className="md:w-1/2 ml-3">
              <img src="/qr-hero-image.png" alt="BoxyQR Analytics Dashboard" className="rounded-lg shadow-xl" />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-gray-100 w-screen right-[50%] relative left-[50%] right-[50%] mx-[-50vw]">
        <div className="container max-w-5xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center mb-12">BoxyQR Features</h2>
          <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="bg-white p-6 rounded-lg shadow-md border-t-4 border-blue-500 flex flex-col h-full">
          <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold">QR Codes</h3>
              </div>
              <p className="text-gray-600 mb-4">Create custom QR codes with full analytics. Track locations, devices, and user behavior.</p>
<ul className="space-y-2 text-sm text-gray-600">
  <li className="flex items-center">
    <svg className="h-4 w-4 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
    </svg>
    <span>Custom designs & branding</span>
  </li>
  <li className="flex items-center">
    <svg className="h-4 w-4 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
    </svg>
    <span>Update links without reprinting</span>
  </li>
  <li className="flex items-center">
    <svg className="h-4 w-4 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
    </svg>
    <span>Real-time scan & location data</span>
  </li>
</ul>
<div className="mt-auto pt-4">
    <Link 
      to={`/QRcreator`} 
      className="inline-block text-blue-600 hover:text-blue-800 text-m font-semibold"
    >
      Learn More →
    </Link>
  </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md border-t-4 border-green-500">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold">AI Smart Scanner</h3>
              </div>
              <p className="text-gray-600 mb-4">Scan complex data like product IDs, SNS codes, and more from images. Export to CSV, and create QR codes in bulk.</p>
<ul className="space-y-2 text-sm text-gray-600">
  <li className="flex items-center">
    <svg className="h-4 w-4 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
    </svg>
    <span>Auto-detect custom identifiers</span>
  </li>
  <li className="flex items-center">
    <svg className="h-4 w-4 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
    </svg>
    <span>One-click CSV export</span>
  </li>
  <li className="flex items-center">
    <svg className="h-4 w-4 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
    </svg>
    <span>Batch QR code generation</span>
  </li>
</ul>
<div className="mt-auto pt-4">
    <Link 
      to={`/AIscanner`} 
      className="inline-block text-blue-600 hover:text-blue-800 text-m font-semibold"
    >
      Learn More →
    </Link>
  </div>
</div>
            
            
            
            <div className="bg-white p-6 rounded-lg shadow-md border-t-4 border-indigo-500">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 015.656 0l4 4a4 4 0 01-5.656 5.656l-1.102-1.101" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold">Link Tracking</h3>
              </div>
              <p className="text-gray-600 mb-4">Trackable URLs with analytics. Monitor traffic sources and engagement metrics.</p>
<ul className="space-y-2 text-sm text-gray-600">
  <li className="flex items-center">
    <svg className="h-4 w-4 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
    </svg>
    <span>Update links without resharing</span>
  </li>
  <li className="flex items-center">
    <svg className="h-4 w-4 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
    </svg>
    <span>Track clicks & location data</span>
  </li>
  <li className="flex items-center">
    <svg className="h-4 w-4 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
    </svg>
    <span>Campaign performance insights</span>
  </li>
</ul>
            </div>
          </div>

          {/* Rest of the LandingPage component remains the same */}
          {/* ... */}
          
        </div>

      {/* Design Features */}
      {/* <section className="py-1 bg-gray-100 w-screen right-[50%] relative left-[50%] right-[50%] mx-[-50vw]">
        <div className="container max-w-4xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12">QR code Features</h2>
          <div className="grid md:grid-cols-3 gap-8  mb-8 ">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">Brand-Matched Designs</h3>
              <p className="text-gray-600">Customize colors, shapes, and add your logo to create tracking assets that complement your brand identity.</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">Dynamic Destinations</h3>
              <p className="text-gray-600">Change your QR codes and link destinations anytime without reprinting or recreating - update destinations instantly.</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">Campaign Management</h3>
              <p className="text-gray-600">Organize multiple tracking assets into campaigns and compare performance across marketing initiatives.</p>
            </div>
          </div>
        </div>
      </section> */}
      </section>




      {/* Analytics Showcase */}
      <section className="">

        <div className="container max-w-4xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-center mb-12">QR Code Features</h2>

          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-10 md:mb-0 md:pr-10">
              <h2 className="text-3xl font-bold mb-6">Complete Tracking Ecosystem</h2>
              <p className="text-lg text-gray-600 mb-6">
                Our unified platform provides detailed analytics for both QR codes and link tracking in one dashboard, giving you complete visibility into your marketing performance.
              </p>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Update destinations without reprinting or resharing</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Track both QR scans and link clicks in one place</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>See engagement down to city level</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Monitor by device type</span>
                </li>
              </ul>
              <Link 
      to={`/sign-up`} 
      className="mt-5 inline-block text-blue-600 hover:text-blue-800 text-m font-semibold"
    >
      It's Free, Try It →
    </Link>
            </div>
            <div className="md:w-1/2">
              <div className="">
                <img src="/analytics.png" alt="BoxyQR Analytics Dashboard" className="rounded" 
                     onError={(e) => {e.target.onerror = null; e.target.src = "/analytics.png";}} />
              </div>
            </div>
          </div>
        </div>
        
      </section>

      <section className="py-16">
        <div className="container max-w-4xl mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2">
              <div className="">
                <img src="/custom.png" alt="BoxyQR customization options" className="rounded" 
                     onError={(e) => {e.target.onerror = null; e.target.src = "/custom.png";}} />
              </div>
            </div>
            <div className="md:w-1/2 mb-10 md:mb-0 md:pl-10 md:pr-0">
              <h2 className="text-3xl font-bold mt-2 mb-6">Easy and customizable</h2>
              <p className="text-lg text-gray-600 mb-6">
              Make your QR codes exactly how you want them. Our simple design tools let you create QR codes that look great and still work perfectly.              </p>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Choose colors that match your brand</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Add your own images or logos</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>See how it looks in real-time as you create</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Then easily share and start seeing engagement</span>
                </li>
              </ul>
              <Link 
      to={`/sign-up`} 
      className="mt-5 inline-block text-blue-600 hover:text-blue-800 text-m font-semibold"
    >
      It's Free, Try It →
    </Link>
            </div>
          </div>
        </div>
        
        
      </section>

      <section className="py-16">
  <div className="container max-w-4xl mx-auto px-6">
    <div className="flex flex-col md:flex-row items-center">
      <div className="md:w-1/2 mb-10 md:mb-0 md:pr-10">
        <h2 className="text-3xl font-bold mb-6">AI-Powered Scanner</h2>
        <p className="text-lg text-gray-600 mb-6">
          Upload or take photos and tell us what to extract. Our AI instantly pulls product IDs, SNS codes, and more, saving you hours of manual data entry.
        </p>
        <ul className="space-y-4">
          <li className="flex items-start">
            <svg className="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
            <span>Simple guided extraction from any image</span>
          </li>
          <li className="flex items-start">
            <svg className="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
            <span>Bulk export to CSV with one click</span>
          </li>
          <li className="flex items-start">
            <svg className="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
            <span>Convert data directly to trackable QR codes</span>
          </li>
          <li className="flex items-start">
            <svg className="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
            <span>Process hundreds of entries in minutes</span>
          </li>
          <li className="flex items-start">
            <svg className="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
            <span>Change URLs at any point</span>
          </li>
        </ul>

              <Link 
              to={`/sign-up`} 
              className="mt-5 inline-block text-blue-600 hover:text-blue-800 text-m font-semibold"
            >
              It's Free, Try It →
            </Link>
      </div>
      <div className="md:w-1/2">
        <div className="">
          <img src="/scanner.gif" alt="BoxyQR AI Scanner in action" className="rounded shadow-lg" 
               onError={(e) => {e.target.onerror = null; e.target.src = "/scanner-fallback.png";}} />
        </div>
      </div>
    </div>
  </div>
</section>
<div className="container p-10 max-w-4xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8  mb-8 ">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">Brand-Matched Designs</h3>
              <p className="text-gray-600">Customize colors, shapes, and add your logo to create tracking assets that complement your brand identity.</p>

              
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">Dynamic Destinations</h3>
              <p className="text-gray-600">Change your QR codes and link destinations anytime without reprinting or recreating - update destinations instantly.</p>
              
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">Campaign Management</h3>
              <p className="text-gray-600">Organize multiple tracking assets into campaigns and compare performance across marketing initiatives.</p>
            </div>
          </div>

        </div>

      <section className="px-1 mb-12 bg-gray-100 w-screen right-[50%] relative left-[50%] right-[50%] mx-[-50vw]">
        <div className="container max-w-4xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center mb-12">Data-Driven Tracking in 3 Steps</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-r from-blue-600 to-indigo-700 rounded-full text-white flex items-center justify-center text-3xl font-bold mx-auto mb-4">1</div>
              <h3 className="text-xl font-semibold mb-2">Create Account</h3>
              <p className="text-gray-600">Sign up instantly</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-r from-blue-600 to-indigo-700 rounded-full text-white flex items-center justify-center text-3xl font-bold mx-auto mb-4">2</div>
              <h3 className="text-xl font-semibold mb-2">Generate Assets</h3>
              <p className="text-gray-600">Custom QRs & trackable links</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-r from-blue-600 to-indigo-700 rounded-full text-white flex items-center justify-center text-3xl font-bold mx-auto mb-4">3</div>
              <h3 className="text-xl font-semibold mb-2">Deploy & Measure</h3>
              <p className="text-gray-600">See who clicks where</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white py-16 w-screen right-[50%] relative left-[50%] right-[50%] mx-[-50vw]">
        <div className="container  max-w-2xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-4">Ready to get started?</h2>
          <p className="text-xl mb-2 max-w-2xl mx-auto">Join other data-driven businesses using BoxyQR to customize and track QR codes and links.</p>
<div className="flex justify-center p-3">
  <div className="grid w-full max-w-2xl md:grid-cols-2 gap-4 mb-1 ">
      <Link to="/sign-up" className="flex justify-center bg-white text-blue-700 border-2 border-white hover:bg-blue-200 hover:text-blue-800 px-10 py-5 rounded-lg font-semibold transition text-center duration-200">
      Create for Free
    </Link>
    
    <Link to="/benefits" className="flex bg-transparent justify-center border-2 text-white border-white hover:bg-blue-600 hover:text-white px-10 py-5 rounded-lg font-semibold text-center transition duration-200">
      Benefits & Pricing
    </Link>
    
  </div>
</div>
          <p className="mt-2 text-sm opacity-80">QR codes & link tracking • Real-time analytics</p>
          </div>
          
      </section>
    </div>
    
  );
}

export default LandingPage;

// // client/src/pages/LandingPage.js
// import React from 'react';
// import { Link } from 'react-router-dom';
// import { useAuth } from '@clerk/clerk-react';
// import { Navigate } from 'react-router-dom';


// function LandingPage() {
//   const { isSignedIn } = useAuth();
  
//   // If user is signed in, redirect to dashboard
//   if (isSignedIn) {
//     return <Navigate to="/dashboard" replace />;
//   }
  

//   return (
//     <div className="landing-page">
//       {/* Hero Section */}
//       <section className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white py-20 mt-0 w-screen right-[50%] relative left-[50%] right-[50%] mx-[-50vw]">
//   <div className="container max-w-4xl mx-auto px-6">
//     <div className="flex flex-col md:flex-row  items-center ">
//       <div className="md:w-1/2 mb-10 md:mb-0">
//         <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-4">
//                 Create Custom QR Codes in Seconds
//               </h1>
//               <p className="text-xl mb-8">
//                 Generate professional, customizable QR codes for your business, events, or personal use. Track scans, customize appearance, update links, and manage all your QR codes in one place.
//               </p>
//               <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
//                 <Link to="/register" className="bg-white text-indigo-600 hover:bg-gray-100 px-6 py-3 rounded-lg font-medium text-center">
//                   Get Started - It's Free
//                 </Link>
//                 <Link to="/create" className="bg-transparent border-2 border-white hover:bg-white hover:text-indigo-600 px-6 py-3 rounded-lg font-medium text-center transition duration-200">
//                   Try It Now
//                 </Link>
//               </div>
//             </div>
//             <div className="md:w-1/2">
//               <img src="/qr-hero-image.png" alt="BoxyQR Example" className="rounded-lg shadow-xl" />
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Features Section */}
//       <section className="py-16 bg-gray-50 w-screen right-[50%] relative left-[50%] right-[50%] mx-[-50vw]">
//         <div className="container max-w-4xl mx-auto px-6">
//           <h2 className="text-3xl font-bold text-center mb-12">Why Choose BoxyQR?</h2>
//           <div className="grid md:grid-cols-3 gap-8">
//             <div className="bg-white p-6 rounded-lg shadow-md">
//               <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mb-4">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
//                 </svg>
//               </div>
//               <h3 className="text-xl font-semibold mb-2">Customizable Designs</h3>
//               <p className="text-gray-600">Create QR codes with custom colors, shapes, and logos to match your brand identity.</p>
//             </div>

//             <div className="bg-white p-6 rounded-lg shadow-md">
//               <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mb-4">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
//                 </svg>
//               </div>
//               <h3 className="text-xl font-semibold mb-2">Detailed Analytics</h3>
//               <p className="text-gray-600">Track scans in real time. See when, where, and how often your QR codes are scanned.</p>
//             </div>

//             <div className="bg-white p-6 rounded-lg shadow-md">
//               <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mb-4">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
//                 </svg>
//               </div>
//               <h3 className="text-xl font-semibold mb-2">Dynamic QR Codes</h3>
//               <p className="text-gray-600">Update your QR code destinations anytime without reprinting them.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* How It Works */}
//       <section className="py-16">
//         <div className="container max-w-4xl mx-auto px-6">
//           <h2 className="text-3xl font-bold text-center mb-12">How It Works</h2>
//           <div className="grid md:grid-cols-4 gap-6 text-center">
//             <div>
//               <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-indigo-700 rounded-full text-white flex items-center justify-center text-2xl font-bold mx-auto mb-4">1</div>
//               <h3 className="text-xl font-semibold mb-2">Create Account</h3>
//               <p className="text-gray-600">Sign up for free in less than a minute</p>
//             </div>
//             <div>
//               <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-indigo-700 rounded-full text-white flex items-center justify-center text-2xl font-bold mx-auto mb-4">2</div>
//               <h3 className="text-xl font-semibold mb-2">Design QR Code</h3>
//               <p className="text-gray-600">Customize colors, add logo, select shape</p>
//             </div>
//             <div>
//               <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-indigo-700 rounded-full text-white flex items-center justify-center text-2xl font-bold mx-auto mb-4">3</div>
//               <h3 className="text-xl font-semibold mb-2">Download & Share</h3>
//               <p className="text-gray-600">Use your QR code anywhere you need it</p>
//             </div>
//             <div>
//               <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-indigo-700 rounded-full text-white flex items-center justify-center text-2xl font-bold mx-auto mb-4">4</div>
//               <h3 className="text-xl font-semibold mb-2">Track Performance</h3>
//               <p className="text-gray-600">Monitor scans and optimize your QR codes</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white py-16 w-screen right-[50%] relative left-[50%] right-[50%] mx-[-50vw]">
//         <div className="container mx-auto px-6 text-center">
//           <h2 className="text-3xl font-bold mb-4">Ready to create your first QR code?</h2>
//           <p className="text-xl mb-8 max-w-2xl mx-auto">Join thousands of businesses and individuals who use BoxyQR to connect the physical and digital worlds.</p>
//           <Link to="/register" className="bg-white text-indigo-700 hover:bg-gray-100 px-8 py-4 rounded-lg font-medium inline-block">
//             Start Creating For Free
//           </Link>
//         </div>
//       </section>
//     </div>
//   );
// }

// export default LandingPage;